import { create } from 'zustand';

type ServerStatusStore = {
  serverIsDown: boolean;
  setServerIsDown: (status: boolean) => void;
};

export const useServerStatusStore = create<ServerStatusStore>((set) => ({
  serverIsDown: false,
  setServerIsDown: (status) => set({ serverIsDown: status }),
}));
